import axios from "axios";
import { Message } from "element-ui";

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL || "", // 基础URL，从环境变量配置，开发环境为空（使用代理），生产环境为实际API地址
  timeout: 10000, // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    // 从localStorage获取语言设置，默认为zh-CN
    const language = localStorage.getItem("language") || "zh-CN";

    // 添加Accept-Language header
    config.headers["Accept-Language"] = language;

    return config;
  },
  (error) => {
    // 请求错误处理
    console.error("Request error:", error);
    return Promise.reject(error);
  }
);

// response拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;

    // 根据后端返回的数据结构处理
    // 数据结构: { data: {}, code: 0, msg: '' }
    if (res.code !== undefined) {
      // 如果code为0，表示成功
      if (res.code === 200) {
        return res.data;
      } else {
        // code不为0，表示业务错误
        const errorMsg = res.msg || "请求失败";
        Message.error(errorMsg);
        return Promise.reject(new Error(errorMsg));
      }
    }

    // 如果没有code字段，直接返回原始数据
    return res;
  },
  (error) => {
    // HTTP错误处理
    console.error("Response error:", error);
    let errorMsg = "请求失败";

    if (error.response) {
      // 服务器返回了错误状态码
      const status = error.response.status;
      switch (status) {
        case 400:
          errorMsg = "请求参数错误";
          break;
        case 401:
          errorMsg = "未授权，请重新登录";
          break;
        case 403:
          errorMsg = "拒绝访问";
          break;
        case 404:
          errorMsg = "请求地址不存在";
          break;
        case 500:
          errorMsg = "服务器内部错误";
          break;
        case 502:
          errorMsg = "网关错误";
          break;
        case 503:
          errorMsg = "服务不可用";
          break;
        case 504:
          errorMsg = "网关超时";
          break;
        default:
          errorMsg = `请求失败 (${status})`;
      }
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      errorMsg = "网络连接失败，请检查网络";
    } else {
      // 其他错误
      errorMsg = error.message || "请求失败";
    }

    Message.error(errorMsg);
    return Promise.reject(error);
  }
);

export default service;
